import { useEffect } from 'react';
import Image from 'next/image';
import gsap from 'gsap';

const AnimCard5 = () => {
  useEffect(() => {
    gsap.to('.clockwise-1-js', {
      rotate: '3600deg',
      duration: 60,
      ease: 'none',
      repeat: -1
    });
    gsap.to('.clockwise-2-js', {
      rotate: '3600deg',
      duration: 180,
      ease: 'none',
      repeat: -1
    });

    gsap.context(() => {
      gsap
        .timeline({
          repeat: -1
        })
        .fromTo(
          '.anim-card-5-clock-js',
          {
            scale: 1.1,
            autoAlpha: 0
          },
          {
            scale: 1,
            autoAlpha: 1
          }
        )
        .fromTo(
          '.anim-card-5-box-js',
          {
            y: -20,
            autoAlpha: 0
          },
          {
            y: 0,
            autoAlpha: 1,
            stagger: 0.3,
            ease: 'bounce.out'
          }
        )
        .to('.anim-card-5-clock-js', {
          y: 1,
          duration: 3
        });
    });
  }, []);

  return (
    <>
      <div className="absolute top-[40%] left-1/2 -translate-y-1/2 -translate-x-1/2 | anim-card-5-clock-js">
        <div className="relative w-78 h-78 rounded-full bg-orange">
          <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
            <div className="relative w-69 h-69 rounded-full bg-white bg-opacity-20">
              <div className="absolute top-10 left-1/2 -translate-x-1/2 w-1 h-26 bg-white origin-bottom clockwise-1-js"></div>
              <div className="absolute top-19 left-1/2 -translate-x-1/2 w-1 h-17 bg-white bg-opacity-40 origin-bottom clockwise-2-js"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-[12%] left-[10%] | anim-card-5-box-js">
        <Image
          src="/images/animcards/5/box.svg"
          width={60}
          height={73}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute bottom-[12%] left-[20%] | anim-card-5-box-js">
        <Image
          src="/images/animcards/5/box2.svg"
          width={60}
          height={35}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
    </>
  );
};
export default AnimCard5;
